import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";

function CollageRegistration_step_3({
  register,
  getValues,
  setValue,
  errors,
  watch,
}) {
  console.log(getValues("send_s_abroad"), "getValues");

  const sendAbroad = watch("send_s_abroad");

  return (
    <>
      <h5 className="step-heading">C. International Mobility Information</h5>

      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Authorization to Send Students Abroad</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="Yes"
                  value="1"
                  {...register("send_s_abroad", {
                    required: "Please select an option",
                  })}
                />

                {/* NO */}
                <Form.Check
                  type="radio"
                  label="No"
                  value="0"
                  {...register("send_s_abroad", {
                    required: "Please select an option",
                  })}
                />
              </div>

              {errors?.send_s_abroad && (
                <Form.Text className="text-danger">
                  {errors.send_s_abroad.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {sendAbroad == 1 && (
            <>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>International Office Contact Email</Form.Label>
                  <Form.Control
                    type="email"
                    {...register("abroad_off_contact", {
                      required:
                        "International Office Contact Email is required",

                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                    placeholder="International Office Contact Email"
                  />
                  {errors.abroad_off_contact && (
                    <Form.Text className="text-danger">
                      {errors.abroad_off_contact.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>No of student send overseas per year</Form.Label>
                  <Form.Control
                    type="number"
                    {...register("abroad_stu_quantity", {
                      required:
                        "No of student send overseas per year is required",
                    })}
                    placeholder="No of student send overseas per year"
                  />
                  {errors.abroad_stu_quantity && (
                    <Form.Text className="text-danger">
                      {errors.abroad_stu_quantity.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default CollageRegistration_step_3;
